<template>
    <div class="articleViewBox">
        <div class="single-img">
            <img :src="dataList.uploadfiles" alt="">
        </div>
        <div class="page-detail-title">
            <div class="page-detail-title-wrap">
                <div class="product-title">
                    <h3 class="product-title-text">{{ dataList.title }}</h3>
                    <div class="share"><i class="font-icon font-icon-fenx"></i><span class="share-text">分享</span></div>
                </div>
                <div class="page-detail-summary" v-if="data.zhaiyao">
                    {{ dataList.description }}
                </div>
            </div>
        </div>
        <el-tabs v-model="activeNmane">
            <el-tab-pane label="详情" name="1">
                <div class="dataContent" v-html="dataList.content">

                </div>
            </el-tab-pane>

        </el-tabs>

        <div class="page-detail-bottom-contact" :style="{ background: data.color1 }" v-if="data.lianxi">
            <div class="telephone"><i class="font-icon font-icon-phone"></i></div>
            <div class="message"><i class="font-icon font-icon-liuyan"></i> 留言咨询 </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'productDetailsView',
  props: {
    data: Object
  },
  data () {
    return {
      dataList: {
        id: 769,
        slug: '769',
        cid: 3,
        productnum: '1725495081',
        title: 'XE205GA中型挖掘机',
        uploadfiles:
                    '//cdn.myxypt.com/3c4f22d1/24/09/9df67811f0016aa998c781ba26f859d9fb94b284.jpg',
        content:
                    '<p>定制化康明斯双增压发动机，高效可调二级增压，可提供媲美六缸机的动力性能与高原适应能力；</p><p><br></p><p>全电控液压系统，响应速度快，操控柔和，油耗较国三低至少8%；</p><p><br></p><p>增加舒适模式和标准模式，冲击幅度可调，满足不同用户对操控性的需求；</p><p><br></p><p>EGR+DOC+DPF后处理技术，无需添加尿素，使用成本和故障率更低；</p><p><br></p><p>保养周期长，超长寿命液压油，质保期≥4000h，减少维护成本。</p><p><br></p>',
        price: '0.00',
        stock: 0,
        hits: 2,
        isgood: 0,
        istop: 0,
        ishead: 0,
        flag: 1,
        timeline: 1725495081,
        orders: 17,
        ptitle: '',
        pdescription: '',
        level: 0,
        description:
                    'XE205GA液压挖掘机是我公司采用全新的设计理念，综合上一代产品的经验积累，依托试验测试体系，进行全面升级的新一代国四产品。该产品采用全电控液压系统，无需节流，功率利用率高，性能先进，操控流畅；采用全新一代驾驶室，增大视野面积、室内噪声更低，操作环境舒适安全；保养件均触手可及，保养方便，节省维护时间，提高工作效率。广泛适用于农田水利、河道清淤、市政建设，可实现挖掘、破碎、拆除等不同作业需求，具有较好的工况适应性，环境适应性。',
        tag: null,
        video: '',
        yang: '',
        name: 'XE205GA中型挖掘机',
        media: [
          {
            type: 'image',
            url:
                            '//cdn.myxypt.com/3c4f22d1/24/09/9df67811f0016aa998c781ba26f859d9fb94b284.jpg'
          }
        ],
        summary:
                    'XE205GA液压挖掘机是我公司采用全新的设计理念，综合上一代产品的经验积累，依托试验测试体系，进行全面升级的新一代国四产品。该产品采用全电控液压系统，无需节流，功率利用率高，性能先进，操控流畅；采用全新一代驾驶室，增大视野面积、室内噪声更低，操作环境舒适安全；保养件均触手可及，保养方便，节省维护时间，提高工作效率。广泛适用于农田水利、河道清淤、市政建设，可实现挖掘、破碎、拆除等不同作业需求，具有较好的工况适应性，环境适应性。',
        created_at: '2024-09-05 08:11:21',
        cate: {
          cid: 3,
          slug: '3',
          cname: '中型挖掘机',
          word: null,
          parentid: 0,
          depth: 0,
          orders: 3,
          flag: 1,
          elite: 0,
          intro: '',
          timeline: 1665449730,
          img:
                        '//cdn.myxypt.com/3c4f22d1/24/09/b2d170f159eb975b1f5e8521379f59e24a7fe6d2.jpg',
          linktype: 1,
          linkurl: '',
          target: 1,
          front: 1,
          content: '',
          custom: 0,
          title: '',
          description: '',
          banner: '',
          id: 3,
          name: '中型挖掘机'
        }
      },
      activeNmane: '1'
    }
  },
  methods: {},
  mounted () {
    console.log(this.data)
  }
}
</script>

<style scoped>
.articleViewBox {
    background: #ffffff;
}

.single-img img {
    width: 100%;
    display: block;
}

.product-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.page-detail-title {
    padding: 10px;
}

.page-detail-title h3 {
    font-size: 16px;
    font-weight: 700;
    color: #333;
    margin: 2px 0 5px 0;
}

.product-title .share {
    position: absolute;
    right: 0;
    width: 60px;
    height: 24px;
    background: #f5f5f5;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.dataContent {
    padding: 0 10px;
}

/deep/ .el-tabs__nav {
    transform: translateX(10px) !important;
}

.page-detail-bottom-contact {
    position: relative;
    width: 100%;
    height: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    top: auto;
    display: flex;
    z-index: 99;
    text-align: center;
}

.page-detail-bottom-contact .font-icon {
    font-size: 21px;
}

.page-detail-bottom-contact div {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.page-detail-bottom-contact .telephone {
    width: 80px;
    background-color: #f5f5f5;
    height: 100%;
}

.page-detail-bottom-contact .message .font-icon {
    margin-right: 0.5em;
}

.page-detail-bottom-contact .message {
    width: calc(100% - 80px);
    font-size: 15px;
    font-weight: 400;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/article/productDetailsView.vue